<template>
	<div>
		<div class="xs-12 fs4 fw7 mt6 mb2">
			请填写适用于个人参保人的财富来源的所有部分。至少应填写完一个部分。
			我们保留要求提供更多有关财富来源的信息和文件的权利。
		</div>
		<case-form :schema="overview" />
		<div class="xs-12 fs4 fw7 mt6 mb2">
			来自投资回报/私人投资者的收益(提示:如果投资资金来自营业利润,企业出售,工资或遗产,请填写适用的部分。)
		</div>
		<j-accordion
			v-for="i in 4"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">详情</span>
				{{ i }}
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="schemaInvestment(i)" :isBoxed="false" />
			</div>
		</j-accordion>
		<case-form :schema="schemaInvestmentOthers" />
		<div class="xs-12 fs4 fw7 mt6 mb2">工资/奖金</div>
		<case-form :schema="schemaSalary" />
		<div class="xs-12 fs4 fw7 mt6 mb2">营业收入/利润</div>
		<case-form :schema="schemaBusiness" />
		<div class="xs-12 fs4 fw7 mt6 mb2">公司出售</div>
		<case-form :schema="schemaCompany" />
		<div class="xs-12 fs4 fw7 mt6 mb2">租金收入</div>
		<j-accordion
			v-for="i in 3"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">详情</span>
				{{ i }}
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="schemaRental(i)" :isBoxed="false" />
			</div>
		</j-accordion>
		<div class="xs-12 fs4 fw7 mt6 mb2">物业出售</div>
		<j-accordion
			v-for="i in 2"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">详情</span>
				{{ i }}
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="schemaProperty(i)" :isBoxed="false" />
			</div>
		</j-accordion>
		<div class="xs-12 fs4 fw7 mt6 mb2">继承或赠与</div>
		<case-form :schema="schemaInheritance" />
		<div class="xs-12 fs4 fw7 mt6 mb2">其他财富来源</div>
		<case-form :schema="schemaOtherSource" />
		<div class="xs-12 fs4 fw7 mt6 mb2">法律监护人</div>
		<case-form :schema="schemaGuardian" />
		<div class="xs-12 fs4 fw7 mt6 mb2">特别说明</div>
		<case-form :schema="schemaSpecialInstructions" />
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"
import JAccordion from "@/components/JAccordion/"

export default {
	components: {
		CaseForm,
		JAccordion
	},

	data() {
		return {}
	},

	computed: {
		overview() {
			return [
				{
					label: "来自投资回报/私人投资者的收益 — 如果勾选此项,请转到 A部分",
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderhasProceedsFromInvestmentCN`,
					props: {
						suggest: {
							typeIncludes: `hasProceedsFromInvestmentCN`
						},
						createOptions: {
							type: `hasProceedsFromInvestmentCN`,
							dataType: "boolean",
							defaultValue: false
						}
					}
				},
				{
					label: "工资/奖金 — 如果勾选此项,请转到 B部分",
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderhasSalaryOrBonusCN`,
					props: {
						suggest: {
							typeIncludes: `hasSalaryOrBonusCN`
						},
						createOptions: {
							type: `hasSalaryOrBonusCN`,
							dataType: "boolean",
							defaultValue: false
						}
					}
				},
				{
					label: "营业收入/利润 — 如果勾选此项,请转到 C部分",
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderhasBusinessIncomeCN`,
					props: {
						suggest: {
							typeIncludes: `hasBusinessIncomeCN`
						},
						createOptions: {
							type: `hasBusinessIncomeCN`,
							dataType: "boolean",
							defaultValue: false
						}
					}
				},
				{
					label: "公司出售 — 如果勾选此项,请转到 D部分",
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderhasCompanySaleCN`,
					props: {
						suggest: {
							typeIncludes: `hasCompanySaleCN`
						},
						createOptions: {
							type: `hasCompanySaleCN`,
							dataType: "boolean",
							defaultValue: false
						}
					}
				},
				{
					label: "租金收入 — 如果勾选此项,请转到 E部分",
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderhasRentalIncomeCN`,
					props: {
						suggest: {
							typeIncludes: `hasRentalIncomeCN`
						},
						createOptions: {
							type: `hasRentalIncomeCN`,
							dataType: "boolean",
							defaultValue: false
						}
					}
				},
				{
					label: "物业出售 — 如果勾选此项,请转到 F部分",
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderhasSaleOfPropertyCN`,
					props: {
						suggest: {
							typeIncludes: `hasSaleOfPropertyCN`
						},
						createOptions: {
							type: `hasSaleOfPropertyCN`,
							dataType: "boolean",
							defaultValue: false
						}
					}
				},
				{
					label: "继承或赠与 — 如果勾选此项,请转到 G部分",
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderhasInheritanceOrGiftCN`,
					props: {
						suggest: {
							typeIncludes: `hasInheritanceOrGiftCN`
						},
						createOptions: {
							type: `hasInheritanceOrGiftCN`,
							dataType: "boolean",
							defaultValue: false
						}
					}
				},
				{
					label: "其他财产来源 — 如果勾选此项,请转到 H部分",
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderhasOtherSourceOfWealthCN`,
					props: {
						suggest: {
							typeIncludes: `hasOtherSourceOfWealthCN`
						},
						createOptions: {
							type: `hasOtherSourceOfWealthCN`,
							dataType: "boolean",
							defaultValue: false
						}
					}
				}
			]
		},
		schemaInvestmentOthers() {
			return [
				{
					label: `请说明用于为上述投资提供资金的财富来源。`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderinvestmentProceedExplanationCN`,
					props: {
						suggest: {
							typeIncludes: `investmentProceedExplanationCN`
						},
						createOptions: {
							type: `investmentProceedExplanationCN`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaSalary() {
			return [
				{
					label: `雇主名称`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderemployerNameCN`,
					props: {
						suggest: {
							typeIncludes: `employerNameCN`
						},
						createOptions: {
							type: `employerNameCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `雇主的地址`,
					component: "entityAddress",
					entity: "case.holder",
					relation: "case.holder.addresses",
					bindTo: `case.facts.holderemployerAddressCN`,
					props: {
						suggest: {
							typeIncludes: `employerAddressCN`
						},
						createOptions: {
							type: `employerAddressCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `业务性质 `,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderemployerNatureOfBusinessCN`,
					props: {
						suggest: {
							typeIncludes: `employerNatureOfBusinessCN`
						},
						createOptions: {
							type: `employerNatureOfBusinessCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `职位/职业(如果 退休,请注明最后的职业。) `,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderoccupationPositionAndDutiesCN`,
					props: {
						suggest: {
							typeIncludes: `occupationPositionAndDutiesCN`
						},
						createOptions: {
							type: `occupationPositionAndDutiesCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `任职时长`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderlengthOfEmploymentCN`,
					props: {
						suggest: {
							typeIncludes: `lengthOfEmploymentCN`
						},
						createOptions: {
							type: `lengthOfEmploymentCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `年薪 (美元) `,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderannualSalaryCN`,
					props: {
						suggest: {
							typeIncludes: `annualSalaryCN`
						},
						createOptions: {
							type: `annualSalaryCN`,
							dataType: "number"
						}
					}
				},
				{
					label: `年平均奖金 (美元) `,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderaverageAnnualBonusCN`,
					props: {
						suggest: {
							typeIncludes: `averageAnnualBonusCN`
						},
						createOptions: {
							type: `averageAnnualBonusCN`,
							dataType: "number"
						}
					}
				}
			]
		},
		schemaBusiness() {
			return [
				{
					label: `公司或生意名称`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderownedBusinessNameCN`,
					props: {
						suggest: {
							typeIncludes: `ownedBusinessNameCN`
						},
						createOptions: {
							type: `ownedBusinessNameCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `年度公司利润 (USD)`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderownedBusinessAnnualProfitCN`,
					props: {
						suggest: {
							typeIncludes: `ownedBusinessAnnualProfitCN`
						},
						createOptions: {
							type: `ownedBusinessAnnualProfitCN`,
							dataType: "number"
						}
					}
				},
				{
					label: `永久地址`,
					component: "entityAddress",
					entity: "case.holder",
					relation: "case.holder.addresses",
					bindTo: `case.facts.holderownedBusinessAddressCN`,
					props: {
						suggest: {
							typeIncludes: `ownedBusinessAddressCN`
						},
						createOptions: {
							type: `ownedBusinessAddressCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `网址`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderownedBusinessWebsiteURLCN`,
					props: {
						suggest: {
							typeIncludes: `ownedBusinessWebsiteURLCN`
						},
						createOptions: {
							type: `ownedBusinessWebsiteURLCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `业务性质(请详细描述业务类型以及提供的产 品或服务。)`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderownedBusinessNatureOfBusinessCN`,
					props: {
						suggest: {
							typeIncludes: `ownedBusinessNatureOfBusinessCN`
						},
						createOptions: {
							type: `ownedBusinessNatureOfBusinessCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `如果参保人是该 企业的所有者/主要负责人,那么您拥有或担任该企业的负责人已有多少年?`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderownedBusinessDurationCN`,
					props: {
						suggest: {
							typeIncludes: `ownedBusinessDurationCN`
						},
						createOptions: {
							type: `ownedBusinessDurationCN`,
							dataType: "number"
						}
					}
				},
				{
					label: `公司成立或该实体创建、组成、治理的所在国家。`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderownedBusinessCountryCN`,
					props: {
						suggest: {
							typeIncludes: `ownedBusinessCountryCN`
						},
						createOptions: {
							type: `ownedBusinessCountryCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `注册或成立日期(日/月/年)`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderownedBusinessRegistrationDateCN`,
					props: {
						suggest: {
							typeIncludes: `ownedBusinessRegistrationDateCN`
						},
						createOptions: {
							type: `ownedBusinessRegistrationDateCN`,
							dataType: "date"
						}
					}
				}
			]
		},
		schemaCompany() {
			return [
				{
					label: `出售公司的名称`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.holdersoldCompanyName`,
					props: {
						suggest: {
							typeIncludes: `soldCompanyName`
						},
						createOptions: {
							type: `soldCompanyName`,
							dataType: "string"
						}
					}
				},
				{
					label: `公司性质(经营活动)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.holdersoldCompanyBusinessNature`,
					props: {
						suggest: {
							typeIncludes: `soldCompanyBusinessNature`
						},
						createOptions: {
							type: `soldCompanyBusinessNature`,
							dataType: "string"
						}
					}
				},
				{
					label: `总收益/售价`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.holdersoldCompanyTotalProceeds`,
					props: {
						suggest: {
							typeIncludes: `soldCompanyTotalProceeds`
						},
						createOptions: {
							type: `soldCompanyTotalProceeds`,
							dataType: "number"
						}
					}
				},
				{
					label: `客户持股比例`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.holdersoldCompanyClientShare`,
					props: {
						suggest: {
							typeIncludes: `soldCompanyClientShare`
						},
						createOptions: {
							type: `soldCompanyClientShare`,
							dataType: "number"
						}
					}
				},
				{
					label: `出售日期(日/月/年)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.holdersoldCompanyDateOfSale`,
					props: {
						suggest: {
							typeIncludes: `soldCompanyDateOfSale`
						},
						createOptions: {
							type: `soldCompanyDateOfSale`,
							dataType: "date"
						}
					}
				}
			]
		},
		schemaInheritance() {
			return [
				{
					label: `资金继承或赠送来源人姓名`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderinheritanceNameOfPersonCN`,
					props: {
						suggest: {
							typeIncludes: `inheritanceNameOfPersonCN`
						},
						createOptions: {
							type: `inheritanceNameOfPersonCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `与参保人的关系`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderinheritanceRelationshipToParticipantCN`,
					props: {
						suggest: {
							typeIncludes: `inheritanceRelationshipToParticipantCN`
						},
						createOptions: {
							type: `inheritanceRelationshipToParticipantCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `资金继承或赠送来源人的财产来源`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderinheritancePersonSourceOfWealthCN`,
					props: {
						suggest: {
							typeIncludes: `inheritancePersonSourceOfWealthCN`
						},
						createOptions: {
							type: `inheritancePersonSourceOfWealthCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `赠与总金额(美元)`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderinheritanceTotalAmountCN`,
					props: {
						suggest: {
							typeIncludes: `inheritanceTotalAmountCN`
						},
						createOptions: {
							type: `inheritanceTotalAmountCN`,
							dataType: "number"
						}
					}
				},
				{
					label: `赠与理由(如适用)`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderinheritanceReasonCN`,
					props: {
						suggest: {
							typeIncludes: `inheritanceReasonCN`
						},
						createOptions: {
							type: `inheritanceReasonCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `继承或赠与日期(年/月/日) `,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderinheritanceDateCN`,
					props: {
						suggest: {
							typeIncludes: `inheritanceDateCN`
						},
						createOptions: {
							type: `inheritanceDateCN`,
							dataType: "date"
						}
					}
				},
				{
					label: `可证实继承或赠与的 代理人/律师姓名 `,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderinheritanceNameOfSolicitorCN`,
					props: {
						suggest: {
							typeIncludes: `inheritanceNameOfSolicitorCN`
						},
						createOptions: {
							type: `inheritanceNameOfSolicitorCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `代理人/律师的联系方式(办公地址,电话 号码和电子邮件地址) `,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderinheritanceSolicitorContactInformationCN`,
					props: {
						suggest: {
							typeIncludes: `inheritanceSolicitorContactInformationCN`
						},
						createOptions: {
							type: `inheritanceSolicitorContactInformationCN`,
							dataType: "string"
						}
					}
				}
			]
		},
		schemaOtherSource() {
			return [
				{
					label: `请详细描述`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderotherSourceOfWealthDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `otherSourceOfWealthDetailsCN`
						},
						createOptions: {
							type: `otherSourceOfWealthDetailsCN`,
							dataType: "string"
						}
					}
				}
			]
		},
		schemaGuardian() {
			return [
				{
					label: `收益付给– 法定监护人姓名 *`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderlegalGuardianNameCN`,
					props: {
						suggest: {
							typeIncludes: `legalGuardianNameCN`
						},
						createOptions: {
							type: `legalGuardianNameCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `出生日期`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderlegalGuardianDateofBirthCN`,
					props: {
						suggest: {
							typeIncludes: `legalGuardianDateofBirthCN`
						},
						createOptions: {
							type: `legalGuardianDateofBirthCN`,
							dataType: "date"
						}
					}
				},
				{
					label: `受其监护的人`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderlegalGuardianForCN`,
					props: {
						suggest: {
							typeIncludes: `legalGuardianForCN`
						},
						createOptions: {
							type: `legalGuardianForCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `当前居住地址`,
					component: "entityAddress",
					entity: "case.holder",
					relation: "case.holder.addresses",
					bindTo: `case.facts.holderlegalGuardianAddressCN`,
					props: {
						suggest: {
							typeIncludes: `legalGuardianAddressCN`
						},
						createOptions: {
							type: `legalGuardianAddressCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `上述法定监护人是否为政治公众人物或其近亲?`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderlegalGuardianIsPEPCN`,
					props: {
						suggest: {
							typeIncludes: `legalGuardianIsPEPCN`
						},
						createOptions: {
							type: `legalGuardianIsPEPCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `如为“是”, 请提供法定监护人姓名、职称/职衔以及详细职责,或如为政治公众人物的近亲,请提供与该政治公众人物的关系性质。`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderlegalGuardianPEPDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `legalGuardianPEPDetailsCN`
						},
						createOptions: {
							type: `legalGuardianPEPDetailsCN`,
							dataType: "string"
						}
					}
				}
			]
		},
		schemaSpecialInstructions() {
			return [
				{
					label: ``,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderspecialInstructionsCN`,
					props: {
						suggest: {
							typeIncludes: `specialInstructionsCN`
						},
						createOptions: {
							type: `specialInstructionsCN`,
							dataType: "string"
						}
					}
				}
			]
		}
	},

	methods: {
		schemaInvestment(i) {
			return [
				{
					label: `投资公司的名称`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderinvestmentProceedNameOfFirm${i}CN`,
					props: {
						suggest: {
							typeIncludes: `investmentProceedNameOfFirm${i}CN`
						},
						createOptions: {
							type: `investmentProceedNameOfFirm${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `公司地点`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderinvestmentProceedLocationOfFirm${i}CN`,
					props: {
						suggest: {
							typeIncludes: `investmentProceedLocationOfFirm${i}CN`
						},
						createOptions: {
							type: `investmentProceedLocationOfFirm${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `您在这家公司开户多久了?`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderinvestmentProceedAccountDuration${i}CN`,
					props: {
						suggest: {
							typeIncludes: `investmentProceedAccountDuration${i}CN`
						},
						createOptions: {
							type: `investmentProceedAccountDuration${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `平均账户余额(美元)`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderinvestmentProceedAccountAverage${i}CN`,
					props: {
						suggest: {
							typeIncludes: `investmentProceedAccountAverage${i}CN`
						},
						createOptions: {
							type: `investmentProceedAccountAverage${i}CN`,
							dataType: "number"
						}
					}
				},
				{
					label: `投资类别`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderinvestmentProceedInvestmentCategory${i}CN`,
					props: {
						suggest: {
							typeIncludes: `investmentProceedInvestmentCategory${i}CN`
						},
						createOptions: {
							type: `investmentProceedInvestmentCategory${i}CN`,
							dataType: "string"
						}
					}
				}
			]
		},
		schemaRental(i) {
			return [
				{
					label: `物业地址`,
					component: "entityAddress",
					entity: "case.holder",
					relation: "case.holder.addresses",
					bindTo: `case.facts.holderrentalPropertyAddress${i}CN`,
					props: {
						suggest: {
							typeIncludes: `rentalPropertyAddress${i}CN`
						},
						createOptions: {
							type: `rentalPropertyAddress${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `物业类型: 单户住宅`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderrentalPropertyForSingle${i}CN`,
					props: {
						suggest: {
							typeIncludes: `rentalPropertyForSingle${i}CN`
						},
						createOptions: {
							type: `rentalPropertyForSingle${i}CN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `物业类型: 多户住宅`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderrentalPropertyForMulti${i}CN`,
					props: {
						suggest: {
							typeIncludes: `rentalPropertyForMulti${i}CN`
						},
						createOptions: {
							type: `rentalPropertyForMulti${i}CN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `物业类型: 商用`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderrentalPropertyForCommercial${i}CN`,
					props: {
						suggest: {
							typeIncludes: `rentalPropertyForCommercial${i}CN`
						},
						createOptions: {
							type: `rentalPropertyForCommercial${i}CN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `年租金收入(美元)`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderrentalPropertyIncome${i}CN`,
					props: {
						suggest: {
							typeIncludes: `rentalPropertyIncome${i}CN`
						},
						createOptions: {
							type: `rentalPropertyIncome${i}CN`,
							dataType: "number"
						}
					}
				}
			]
		},
		schemaProperty(i) {
			return [
				{
					label: `出售物业的地址`,
					component: "entityAddress",
					entity: "case.holder",
					relation: "case.holder.addresses",
					bindTo: `case.facts.holdersoldPropertyAddress${i}CN`,
					props: {
						suggest: {
							typeIncludes: `holdersoldPropertyAddress${i}CN`
						},
						createOptions: {
							type: `holdersoldPropertyAddress${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `请说明用于购买上述物业的财富来源。`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holdersoldPropertyExplanation${i}CN`,
					props: {
						suggest: {
							typeIncludes: `soldPropertyExplanation${i}CN`
						},
						createOptions: {
							type: `soldPropertyExplanation${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `出售日期`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holdersoldPropertyDateOfSale${i}CN`,
					props: {
						suggest: {
							typeIncludes: `soldPropertyDateOfSale${i}CN`
						},
						createOptions: {
							type: `soldPropertyDateOfSale${i}CN`,
							dataType: "date"
						}
					}
				},
				{
					label: `出售总额(美元)`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holdersoldPropertyTotalAmount${i}CN`,
					props: {
						suggest: {
							typeIncludes: `soldPropertyTotalAmount${i}CN`
						},
						createOptions: {
							type: `soldPropertyTotalAmount${i}CN`,
							dataType: "number"
						}
					}
				}
			]
		}
	},

	created() {}
}
</script>
